import "ceyper-common/theme.css";
import "ceyper-common/input.css";

import "ceyper-common";
import App from "./App.svelte";
import "$lib/commands";
import { mount } from "svelte";
import { installTestApi } from "$lib/testApi";

(window as any).clear = () => {
    localStorage.clear();
    location.reload();
};

let app;

try {
    app = mount(App, { target: document.body });
} catch (e) {
    console.error(e);
    confirm("Clear local cache?") && (window as any).clear();
    app = null!;
}

document.body.classList.add("loaded");
installTestApi();

export default app;
